export const reportSupervisionTypes = {
  GET_REPORT_SUPERVISION: 'GET_REPORT_SUPERVISION',
  SET_REPORT_SUPERVISION_FILTERS: 'SET_REPORT_SUPERVISION_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL',
};